import { useLang } from '@/i18n';
import EcoSpace from 'eco-design/base/eco-space';
import styles from './index.module.scss';
import EcoTabSwiper, { EcoTabSwiperItemProps } from 'eco-design/sections/eco-tab-swiper';

const JD: React.FC = () => {
    const { t } = useLang('delta3series');
    const items: EcoTabSwiperItemProps[] = [
        {
            bottomContent: t('D_tab1_desc'),
            tabLabel: t('D_tab1'),
            tabValue: '1',
            pc: 'https://websiteoss.ecoflow.com/upload/image/1740650141022/AC%E5%BF%AB%E5%85%85%20(1).jpg',
            pad: 'https://websiteoss.ecoflow.com/upload/image/1740650141022/AC%E5%BF%AB%E5%85%85%20(1).jpg',
            h5: 'https://websiteoss.ecoflow.com/upload/image/1740650312006/1.jpg',
        },
        {
            bottomContent: t('D_tab2_desc'),
            tabLabel: t('D_tab2'),
            tabValue: '2',
            pc: 'https://websiteoss.ecoflow.com/upload/image/1740650140629/Group%201612706645%20(1).jpg',
            pad: 'https://websiteoss.ecoflow.com/upload/image/1740650140629/Group%201612706645%20(1).jpg',
            h5: 'https://websiteoss.ecoflow.com/upload/image/1740650311846/2.jpg',
        },
        {
            bottomContent: t('D_tab3_desc'),
            tabLabel: t('D_tab3'),
            tabValue: '3',
            pc: 'https://websiteoss.ecoflow.com/upload/image/1740650209938/Group%201612706646%20(1).jpg',
            pad: 'https://websiteoss.ecoflow.com/upload/image/1740650209938/Group%201612706646%20(1).jpg',
            h5: 'https://websiteoss.ecoflow.com/upload/image/1740650312265/3.jpg',
        },
        {
            bottomContent: t('D_tab4_desc'),
            tabLabel: t('D_tab4'),
            tabValue: '4',
            pc: 'https://websiteoss.ecoflow.com/upload/image/1740650140810/Group%201612706647%20(1).jpg',
            pad: 'https://websiteoss.ecoflow.com/upload/image/1740650140810/Group%201612706647%20(1).jpg',
            h5: 'https://websiteoss.ecoflow.com/upload/image/1740650312454/4.jpg',
        },
    ];

    return (
        <div className={styles.comp} id="d3-D">
            <EcoSpace />
            <EcoTabSwiper items={items} />
        </div>
    );
};

export default JD;
